import { render, staticRenderFns } from "./ShopsCollection.vue?vue&type=template&id=1c2160cc&"
import script from "./ShopsCollection.vue?vue&type=script&lang=js&"
export * from "./ShopsCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports